import { useEffect } from "react";

const CURRENT_VERSION = "1.0.1"; // same as meta.json, bump on each deploy

export default function VersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/meta.json", { cache: "no-cache" });
        const data = await res.json();

        if (data.version && data.version !== CURRENT_VERSION) {
          window.location.reload(true); // hard reload with new files
        }
      } catch (e) {
        // ignore errors
      }
    };

    checkVersion();                     // on first load
    const id = setInterval(checkVersion, 60 * 1000); // then every minute
    return () => clearInterval(id);
  }, []);

  return null;
}
